module.exports = __webpack_public_path__ + "static/media/middle.7962f08d.svg";